import { DataTable } from "mantine-datatable";
import React, { useEffect, useState } from "react";
import CustomPagination from "../../components/Layouts/CustomPagination";
import { AiFillEye } from "react-icons/ai";
import HistoryService from "../../service/history.service";
import Swal from "sweetalert2";
import moment from "moment";
import DashboardService from "../../service/dashboard.service";
import DropdownCustom from "../../components/DropdownCustom";
import DateRangePicker from "react-bootstrap-daterangepicker";
// you will also need the css that comes with bootstrap-daterangepicker
import "bootstrap-daterangepicker/daterangepicker.css";
// import DateRangePicker from "react-bootstrap-daterangepicker";
// import 'bootstrap/dist/css/bootstrap.css';
// import "bootstrap-daterangepicker/daterangepicker.css";
import * as ExcelJS from "exceljs";

function LogMessages() {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  // const [allData, setAllData] = useState([]);
  const [page, setPage] = useState(1);
  const PAGE_SIZES = [10, 20, 30, 50, 100];
  const [pageSize, setPageSize] = useState(PAGE_SIZES[0]);
  const [totalData, setTotalData] = useState(0);
  const [date, setDate] = useState();
  const [countryOptions, setCountryOptions] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [expandedRows, setExpandedRows] = useState({});
  const [expandedReceiverRows, setExpandedReceiverRows] = useState({});
  const [isFirst, setIsFirst] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const [logMessage, setLogMessage] = useState("");
  const [startDate, setStartDate] = useState(moment(new Date()).valueOf());
  const [endDate, setEndDate] = useState(moment(new Date()).valueOf());

  const showMessage = (msg, type) => {
    const toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      customClass: { container: "toast" },
    });
    toast.fire({
      icon: type,
      title: "data not found",
      padding: "10px 20px",
    });
  };

  const handleChange = (type, page) => {
    const total = totalData / pageSize;
    const newPage = Math.ceil(total);
    if (type === "Next") {
      if (page !== newPage) {
        setPage(page + 1);
      }
    } else if (type === "Previous") {
      if (page !== 1) {
        setPage(page - 1);
      }
    } else if (type === "First") {
      if (page !== 1) {
        setPage(1);
      }
    } else if (type === "Last") {
      if (page !== newPage) {
        setPage(newPage);
      }
    } else {
      setPage(page);
    }
  };

  const getMessage = async () => {
    setIsFirst(true);
    if (isFirst) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
    // const { date, pageNumber, pageSize } = values;
    console.log("date", date);

    const formattedDate =
      date !== "" && date !== undefined && date !== "Invalid date"
        ? moment(date, "YYYY-MM-DD").valueOf()
        : "";

    try {
      const response = await HistoryService.getLogMessages(
        endDate ? moment(endDate).endOf("D").valueOf() : "",
        logMessage,
        mobileNumber,
        page,
        pageSize,
        startDate ? moment(startDate).startOf("D").valueOf() : ""
        // selectedCountry
      );

      //     endDate,
      // message,
      // mobileNumber,
      // pagenumber,
      // pageSize,
      // startDate

      console.log("response.data.", response.data);

      setData(response.data.apiresponse.data.messages);
      setTotalData(response.data.apiresponse.data.count);
      // setAllData(response.data.apiresponse.data);
    } catch (error) {
      console.log("error", error);

      showMessage(error.message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getMessage();
    const intervalId = setInterval(() => {
      setIsFirst(false);
      getMessage();
    }, 5000);

    return () => clearInterval(intervalId);
  }, [date, endDate, logMessage, mobileNumber, page, pageSize, startDate]);

  const handleDataPerPage = (e) => {
    setPageSize(e.target.value);
  };

  const fetchCountries = async () => {
    try {
      const response = await DashboardService.getCountry();
      const countries = response.data.apiresponse.data;
      const options = countries.map((item) => ({
        value: item,
        label: item,
      }));

      const newObject = [{ value: "", label: "All" }, ...options];

      setCountryOptions(newObject);
    } catch (error) {
      console.error("Failed to fetch countries:", error);
    }
  };

  useEffect(() => {
    fetchCountries();
  }, []);

  // const handleDateChange = (selectedDate) => {
  //   const date = moment(selectedDate.target.value).format("YYYY-MM-DD");
  //   setDate(date);
  // };

  const handleClick = (selectedDate) => {
    const date = moment(selectedDate.target.value).format("YYYY-MM-DD");
    setDate(date);
    setSelectedCountry("");
  };

  const handleChangeCountry = async (e) => {
    setSelectedCountry(e);
  };

  const handleDateChange = (start, end, label) => {
    setStartDate(moment(start).valueOf());
    setEndDate(moment(end).valueOf());
  };

  const handleClear = () => {
    setStartDate("");
    setEndDate("");
  };

  const handleExportExcel = async () => {
    let totalAmount = 0;
    let totalBeforeAmount = 0;
    let totalAfterAmount = 0;
    for (let i = 0; i < data?.length; i++) {
      totalAmount += parseFloat(data[i]?.amount);
      totalBeforeAmount += parseFloat(data[i]?.beforeAmount);
      totalAfterAmount += parseFloat(data[i]?.afterAmount);
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet1");

    const commonCellStyle = {
      fill: {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "CCCCCC" },
      },
      border: {
        top: { style: "thin", color: { argb: "000000" } },
        left: { style: "thin", color: { argb: "000000" } },
        bottom: { style: "thin", color: { argb: "000000" } },
        right: { style: "thin", color: { argb: "000000" } },
      },
      font: { color: { argb: "000000" }, bold: true },
    };

    const titleRow = worksheet.addRow(["Twin-box Users"]);
    worksheet.mergeCells("A1:J1");

    titleRow.getCell(1).font = { ...commonCellStyle.font, size: 12 };
    worksheet.addRow([]);
    worksheet.mergeCells("A2:J2");

    // Add column headers
    const headers = [
      "ID",
      "Message",
      "Sender ID",
      "Receiver ID",
      "Message Time",
      "Date",
    ];
    worksheet.getColumn(1).width = 20; // Column N
    worksheet.getColumn(2).width = 80; // Column Card
    worksheet.getColumn(3).width = 20;
    worksheet.getColumn(4).width = 25;
    worksheet.getColumn(5).width = 22;

    const headerRow = worksheet.addRow(headers);
    headerRow.getCell(1).alignment = { horizontal: "center" };
    headerRow.getCell(2).alignment = { horizontal: "center" };
    headerRow.getCell(3).alignment = { horizontal: "center" };
    headerRow.getCell(4).alignment = { horizontal: "center" };
    headerRow.getCell(5).alignment = { horizontal: "center" };

    headerRow.eachCell((cell) => {
      cell.border = {
        top: { style: "none" },
        left: { style: "none" },
        bottom: { style: "thin", color: { argb: "000000" } },
        right: { style: "none" },
      };
    });

    // Add data rows
    data.forEach((res, index) => {
      const table = worksheet.addRow([
        (page - 1) * pageSize + index + 1,
        res.messageContent ? res.messageContent : "--",
        res.senderId ? res.senderId : "--",
        res.receiverId ? res.receiverId : "--",
        res.messageTime ? res.messageTime : "--",
        res.messageTime !== "0" &&
        res.messageTime !== 0 &&
        res.messageTime !== "" &&
        res.messageTime !== null &&
        res.messageTime !== undefined &&
        res.messageTime !== "null"
          ? moment(Number(res.messageTime)).format("DD/MM/YYYY HH:mm")
          : "--",
        res.creationDate !== "0" &&
        res.creationDate !== 0 &&
        res.creationDate !== "" &&
        res.creationDate !== null &&
        res.creationDate !== undefined &&
        res.creationDate !== "null"
          ? moment(Number(res.creationDate)).format("DD/MM/YYYY HH:mm")
          : "--",
      ]);
      table.getCell(1).alignment = { horizontal: "center" };
      table.getCell(2).alignment = { horizontal: "center" };
      table.getCell(3).alignment = { horizontal: "center" };
      table.getCell(4).alignment = { horizontal: "center" };
      table.getCell(5).alignment = { horizontal: "center" };
      table.eachCell((cell) => {
        cell.border = {
          top: { style: "none" },
          left: { style: "none" },
          bottom: { style: "none" },
          right: { style: "none" },
        };
      });
    });

    worksheet.addRow([]);
    worksheet.addRow([]);

    // Create an Excel file
    const buffer = await workbook.xlsx.writeBuffer();

    // Download the file
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = "Messages.xlsx";
    link.click();
  };

  return (
    <>
      <h5 className="text-lg font-semibold dark:text-white-light mb-3">
        Log Messages
      </h5>

      {/* <DateRangePicker
        initialSettings={{ startDate: "09/01/2024", endDate: "10/01/2024" }}
        // renges={selectionRange}
        // onchange={handleSelect}
      >
        <button className="border-2 rounded-md p-2">Select a Date</button>
      </DateRangePicker> */}

      {/* <div className="flex justify-end">
        <div className="mt-1 mr-2">
          {countryOptions.length > 0 && (
            <DropdownCustom
              data={countryOptions}
              setData={handleChangeCountry}
              name="Country"
            />
          )}
        </div>
        <input
          type="date"
          value={date}
          onChange={handleDateChange}
          className="mt-1 block border border-gray-300 rounded-md p-2 w-54 mb-4"
        />
      </div> */}
      <div className="allfilter flex items-center justify-end gap-3 flex-wrap mb-4">
        <div className="w-full sm:w-fit">
          <input
            type="number"
            placeholder="Mobile Number"
            value={mobileNumber}
            onChange={(e) => setMobileNumber(e.target.value)}
            // onFocus={(e) => e.target.showPicker()}
            className="block border border-gray-300 rounded-md p-2 w-full sm:w-54"
          />
        </div>

        <div className="w-full sm:w-fit">
          <input
            type="text"
            placeholder="Log Message"
            value={logMessage}
            onChange={(e) => setLogMessage(e.target.value)}
            // onFocus={(e) => e.target.showPicker()}
            className="block border border-gray-300 rounded-md p-2 w-full sm:w-54"
          />
        </div>

        <div className="w-full sm:w-fit">
          <DateRangePicker
            onCallback={handleDateChange}
            onCancel={handleClear}
            initialSettings={{
              startDate: moment(new Date()).format("DD/MM/YYYY"),
              endDate: moment(new Date()).format("DD/MM/YYYY"),
              autoUpdateInput: false,
              locale: {
                format: "DD/MM/YYYY",
              },
            }}
          >
            <input
              type="text"
              placeholder="Select Date"
              value={
                startDate && endDate
                  ? `${moment(startDate).format("DD/MM/YYYY")} - ${moment(
                      endDate
                    ).format("DD/MM/YYYY")}`
                  : ""
              }
              defaultValue=""
              onChange={(startDate, endDate) =>
                handleDateChange(startDate, endDate)
              }
              className="block border border-gray-300 rounded-md p-2 w-full sm:w-54"
            />
          </DateRangePicker>
        </div>

        <button
          type="button"
          className="bg-blue-500 text-white rounded px-4 py-2 hover:bg-blue-600"
          onClick={handleExportExcel}
          // disabled={loading}
        >
          Export Excel
        </button>
      </div>

      <DataTable
        noRecordsText="No results match your search query"
        highlightOnHover
        className="whitespace-nowrap table-hover min-w-[780px]"
        records={data}
        columns={[
          {
            accessor: "id",
            title: "ID",
            // sortable: true,
            render: ({ id }, index) => (
              <div>
                <span>{(page - 1) * pageSize + index + 1}</span>
              </div>
            ),
          },
          {
            accessor: "message",
            title: "Message",
            render: ({ messageContent }) => (
              <div className="">
                <span className="!text-xs">
                  {messageContent ? messageContent : "--"}
                </span>
              </div>
            ),
          },
          {
            accessor: "senderId",
            title: "Sender ID",
            render: ({ senderId }) => (
              <div className="">
                <span className="!text-xs">{senderId ? senderId : "--"}</span>
              </div>
            ),
          },
          {
            accessor: "receiverId",
            title: "Receiver ID",
            render: ({ receiverId }) => (
              <div className="">
                <span className="!text-xs">
                  {receiverId ? receiverId : "--"}
                </span>
              </div>
            ),
          },
          {
            accessor: "messageTime",
            title: "Message Time",
            render: ({ messageTime }) => (
              <div className="">
                <span className="!text-xs">
                  {messageTime !== "0" &&
                  messageTime !== 0 &&
                  messageTime !== "" &&
                  messageTime !== null &&
                  messageTime !== undefined &&
                  messageTime !== "null"
                    ? moment(Number(messageTime)).format("DD/MM/YYYY HH:mm")
                    : "--"}
                </span>
              </div>
            ),
          },
          {
            accessor: "creationDate",
            title: "Date",
            render: ({ creationDate }) => (
              <div className="">
                <span className="!text-xs">
                  {creationDate !== "0" &&
                  creationDate !== 0 &&
                  creationDate !== "" &&
                  creationDate !== null &&
                  creationDate !== undefined &&
                  creationDate !== "null"
                    ? moment(Number(creationDate)).format("DD/MM/YYYY HH:mm")
                    : "--"}
                </span>
              </div>
            ),
          },
        ]}
        totalRecords={totalData}
        recordsPerPage={pageSize}
        onPageChange={(p) => setPage(p)}
        recordsPerPageOptions={PAGE_SIZES}
        onRecordsPerPageChange={setPageSize}
        minHeight={200}
        loading={isLoading}
        fetching={isLoading}
      />
      <CustomPagination
        total={totalData}
        page={page}
        handleChange={handleChange}
        dataPerPage={pageSize}
        handleDataPerPage={handleDataPerPage}
        PAGE_SIZES={PAGE_SIZES}
      />
    </>
  );
}

export default LogMessages;
